import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import TextLink from 'LuxKit/TextLink'
import FormatCurrency from 'components/Common/FormatCurrency'
import { useAppSelector } from 'hooks/reduxHooks'
import { getBaseTierOfferWithJoiningFee } from 'selectors/luxPlusSelectors'
import { getHasLuxPlusInAnyRegion, getIsFreePreviewMemberOutsideRegion } from 'luxPlus/selectors/featureToggle'
import { LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'

const FinePrint = styled(BodyText)`
  opacity: 0.8;
`

// Campaign-only fine print, spanning the full hero width below both grid columns, rendered only
// while the campaign is active. The joining-fee waiver sentence only applies to visitors who can
// still purchase LuxPlus+ (not already members, in any region — see getHasLuxPlusInAnyRegion) —
// the evergreen "*Based on savings..." sentence is always shown, stacked directly below it here
// during the campaign, so the standalone Footnote in LuxPlusNonMemberLandingPageContent hides
// itself while this is showing to avoid rendering the same disclaimer twice.
function LuxPlusMonthTakeoverHeroFinePrint() {
  const offer = useAppSelector(getBaseTierOfferWithJoiningFee)
  const hasLuxPlusInAnyRegion = useAppSelector(getHasLuxPlusInAnyRegion)
  const isFreePreviewOutsideRegion = useAppSelector(getIsFreePreviewMemberOutsideRegion)

  return (
    <FinePrint variant="small" colour="normal-contrast">
      {offer && !hasLuxPlusInAnyRegion && !isFreePreviewOutsideRegion && <>
        <FormattedMessage
          id="17JGRxdekmyhGukCne7m"
          defaultMessage="^Joining fee currently waived when purchasing with a travel offer only. {price} annual membership renews on sign-up anniversary. Cancel renewal anytime. <link>T&Cs apply.</link>"
          description="Fine print below the LuxPlus+ Month campaign hero explaining the joining fee waiver and renewal terms"
          values={{
            price: <FormatCurrency value={offer.price} format="roundedDollar" />,
            link: (chunks) => <TextLink size="small" weight="regular" colour="inherit" to={`/${LUXURY_PLUS_PATHS.TERMS_AND_CONDITIONS_PAGE}`}>{chunks}</TextLink>,
          }}
        />
        <br />
      </>}
      <FormattedMessage
        id="2Ffycma3wMHFARz-DEyO"
        defaultMessage="*Based on savings by top 10% of active LuxPlus+ members over 12 months"
        description="Footnote disclaimer about savings calculation on LuxPlus landing page"
      />
    </FinePrint>
  )
}

export default LuxPlusMonthTakeoverHeroFinePrint
